import Component from 'gia/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);

export default class Chiffre extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      chiffre: {}
    };
  }

  mount() {
    let that = this;
    let snap = 10;
    if (this.ref.chiffre.innerText.length == 2) {
      snap = 1;
    }
    gsap.set(this.ref.chiffre, {
      width: this.ref.chiffre.offsetWidth,
    })
    // if (this.ref.chiffre.innerText in  == 3) {}
    if (this.ref.chiffre.innerText % 1 != 0) {
      snap = 0.1;
      if (this.ref.chiffre.innerText * 100 % 10 != 0) {
        snap = 0.01;
      }
    }
    let ticker = this.ref.chiffre.innerText.replace(',', '.');
    const targetObj = {value: 0};

    const formatter = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    gsap.fromTo(targetObj, {
        value: 0
      },
      {
        value: ticker,
        duration: 5,
        scrollTrigger: {
          trigger: this.ref.chiffre,
          start: 'bottom bottom',
        },
        onUpdate: () => {
          console.log(targetObj.value);
          // Snap the raw float number to prevent floating-point artifacts
          let number = targetObj.value;
          // if (snap < 1) {
          //   if ((snap < 0.1) && (number < 4.5)) {
          //     this.ref.chiffre.innerText = gsap.utils.snap(snap * 10, number).toFixed(2);
          //   } else {
          //     this.ref.chiffre.innerText = gsap.utils.snap(snap, number);
          //   }
          // } else {
          //   this.ref.chiffre.innerText = gsap.utils.snap(snap, number);
          // }
          if (snap < 1) {
            console.log(gsap.utils.snap(snap, number))
            this.ref.chiffre.innerText = formatter.format(gsap.utils.snap(snap, number));
          } else {
            this.ref.chiffre.innerText = gsap.utils.snap(snap, number);
          }

          // console.log(this.ref.chiffre.innerText);
          // const snappedValue = snapDecimal(targetObj.value);
        }

      });

  }
}